import config from "../config";
import getAccessToken from "./auth";

export const fetchEmployeeDetails = async (codedCaseId: string): Promise<any> => {
  const accessToken = await getAccessToken();
  const response = await fetch(`${config.apiEndpoint}/api/employee/case-references/${codedCaseId}`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      "x-functions-key": config.functionKey
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch employee details: ${response.statusText}`);
  }

  return response.json();
};
